import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
	selector: 'pcm-table-filter-field-select',
	templateUrl: './table-filter-field-select.component.html',
	styleUrls: ['./table-filter-field-select.component.scss']
})
export class TableFilterFieldSelectComponent implements OnChanges {
	@Input() name: string;
	@Input() value: Array<string> = [];
	@Input() helpMessage: string;
	@Input() options: Array<any> = [];
	@Input() useDropDownMode = false;
	@Output() valueChange = new EventEmitter<Array<string>>();
	@Output() onOptionSelected = new EventEmitter<void>();
	dropdownOptions: Array<any> = [];

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['options']) {
			this.updateDropdownOptions();
		}
	}

	changeValue(event, id): void {
		if (this.useDropDownMode) {
			// using drop down mode for single selection
			this.valueChange.emit([event.item.id]);
		} else {
			// using multi-selection mode (not dropdown mode)
			if (event.checked && this.value) {
				// emit with all previous values, plus the new one
				this.valueChange.emit([...this.value, id]);
			} else if (event.checked) {
				// emit a new list with checked id
				this.valueChange.emit([id]);
			} else {
				this.valueChange.emit(this.value.filter(x => x !== id));
			}
		}

		this.onOptionSelected.emit();
	}

	/**
	 * Check if a specific value is selected
	 */
	isChecked(id): boolean {
		return this.value ? this.value.includes(id) : false;
	}

	/**
	 * Retrieve the label of current single value to show as the selected value in the dropdown menu
	 */
	getLabelDropdown(): string {
		if (this.value) {
			return this.options.filter(o => o.id === this.value[0])[0].label;
		} else {
			return '';
		}
	}

	/**
	 * Read options property to update dropdown-specific list of options
	 */
	updateDropdownOptions(): void {
		this.dropdownOptions = this.options.map((o, i) => {
			const returnValue: any = { content: o.label, id: o.id };
			if (this.value && this.value[0] === o.id) {
				returnValue.selected = true;
			}
			return returnValue;
		});
	}
}
